<div class="profile-container p-4">
    <div *ngIf="loading" class="text-center p-5">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        <p class="mt-2">Loading profile...</p>
    </div>

    <div *ngIf="!loading && userProfile" class="card shadow-sm border-0 overflow-hidden">
        <div class="profile-header bg-primary p-5 text-center text-white">
            <div class="profile-avatar mb-3">
                <i class="pi pi-user-circle" style="font-size: 5rem"></i>
            </div>
            <h2 class="m-0 fw-bold">{{ userProfile.firstName }} {{ userProfile.lastName }}</h2>
            <p class="m-0 opacity-75">&#64;{{ userProfile.username }}</p>
        </div>
        
        <div class="card-body p-4">
            <div class="row">
                <div class="col-md-6 mb-4">
                    <h5 class="text-dark fw-bold mb-3 border-bottom pb-2">Personal Information</h5>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">Full Name</label>
                        <span class="fw-medium">{{ userProfile.firstName }} {{ userProfile.lastName }}</span>
                    </div>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">Email Address</label>
                        <div class="d-flex align-items-center gap-2">
                            <span class="fw-medium">{{ userProfile.email }}</span>
                            <p-tag 
                                [severity]="userProfile.emailVerified ? 'success' : 'warning'" 
                                [value]="userProfile.emailVerified ? 'Verified' : 'Unverified'"
                                [rounded]="true">
                            </p-tag>
                        </div>
                    </div>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">Region</label>
                        <span class="fw-medium">{{ userProfile.region || 'INDIA' }}</span>
                    </div>
                </div>

                <div class="col-md-6 mb-4">
                    <h5 class="text-dark fw-bold mb-3 border-bottom pb-2">Account Status</h5>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">Status</label>
                        <p-tag 
                            [severity]="userProfile.enabled ? 'success' : 'danger'" 
                            [value]="userProfile.enabled ? 'Active' : 'Disabled'">
                        </p-tag>
                    </div>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">Last Login</label>
                        <span class="fw-medium">{{ userProfile.lastLogin ? (userProfile.lastLogin | date:'medium') : 'Never' }}</span>
                    </div>
                    <div class="info-item mb-2">
                        <label class="text-muted small fw-bold text-uppercase d-block">User ID</label>
                        <code class="small text-break">{{ userProfile.id }}</code>
                    </div>
                </div>
            </div>

            <div class="mt-2" *ngIf="userProfile.roles && userProfile.roles.length > 0">
                <h5 class="text-dark fw-bold mb-3 border-bottom pb-2">Assigned Roles</h5>
                <div class="d-flex flex-wrap gap-2">
                    <p-tag *ngFor="let role of userProfile.roles" [value]="role" [rounded]="true" severity="info"></p-tag>
                </div>
            </div>
        </div>
    </div>
</div>
